module.exports = __webpack_public_path__ + "img/colored-arrow.82299a29.svg";